import { useCallback } from "react";
import { Card } from "shared/components/Card";
import { Unit } from "types/landlord/address";
import { UnitCardBody } from "./UnitCardBody";
import { UnitCardPhoto } from "./UnitCardPhoto";

export const UnitCard = ({
  unit,
  onActivityClick,
  visibleFields
}: {
  unit: Unit;
  onActivityClick: (unit: Unit) => void;
  visibleFields: Set<string>;
}) => {
  const shows = useCallback(
    (field: string) => visibleFields.has(field),
    [visibleFields]
  );

  return (
    <Card
      linkTo={`/properties/${unit.property?.id}/units/${unit.id}`}
      className="overflow-hidden"
    >
      <UnitCardPhoto
        unit={unit}
        shows={shows}
        onActivityClick={onActivityClick}
      />
      <UnitCardBody unit={unit} shows={shows} />
    </Card>
  );
};
